import React, {useContext} from 'react';
import {CSSTransition} from 'react-transition-group';
import classNames from "classnames";
import AppContext from "../store";
import Header from "../components/Header/Header";
import WelcomeHolder from '../components/Welcome/WelcomeHolder';
import ConfiguratorMobile from '../components/Configurator/ConfiguratorMobile';
import ConfiguratorDesktop from '../components/Configurator/ConfiguratorDesktop';
import PopupIdle from '../components/PopupIdle/PopupIdle';
import InteractionsPopup from "../components/Interactions/InteractionsPopup";
import HintOverlay from "../components/HintOverlay/HintOverlay";
import useDeviceSizeDetect from "../hooks/useDeviceSizeDetect";
import PopupReady from "../components/PopupReady/PopupReady";

export default function Queue() {
  const {
    isConfiguratorAvailable,
    isInteractionsPortalOpen,
  } = useContext(AppContext);
  const detectMobile = useDeviceSizeDetect();
  
  return (
    <>
      <HintOverlay />
      
      <Header className={classNames({
        'visible-device-small': !isConfiguratorAvailable,
      })}/>
      
      <CSSTransition
        in={!isConfiguratorAvailable}
        appear={true}
        classNames="fade"
        timeout={700}
        mountOnEnter
        unmountOnExit
      >
        <WelcomeHolder />
      </CSSTransition>
      
      
      <CSSTransition
        in={isConfiguratorAvailable}
        appear={true}
        classNames="fade"
        timeout={700}
      >
          {
            detectMobile.isMobile
              ? <ConfiguratorMobile />
              : <ConfiguratorDesktop />
          }
      </CSSTransition>
  
      {
        isConfiguratorAvailable &&
        <>
          {
            isInteractionsPortalOpen && <InteractionsPopup />
          }
          <PopupIdle />
        </>
      }

      <PopupReady />
    </>
  )
}
